import styles from './navbar.module.css';
import NavItem from './navitem';
export default function PageNavbar() {
	return (
		<nav className={styles.navbar}>
			<ul>
				<NavItem title="Transport og Reiser" subitems={["Babyzen Yoyo", "Sportsvogn", "Bilstol", "Bæreseler"]}></NavItem>
				<NavItem title="Sikkerhet" subitems={["Babycall", "Sikkerhetsgrinder"]}></NavItem>
				<NavItem title="Soving" subitems={["Seng", "Madrasser", "Sengetøy", {label: "Smokker", url: "/sok?q=Smokk"},"Sovepose"]}></NavItem>
				<NavItem title="Mat og Ernæring" subitems={["Amming", "Flasker", "Matstoler"]}></NavItem>
				<NavItem title="Helse og Velvære" subitems={["Badeutstyr", "Stell", "Pleieprodukter"]}></NavItem>
				<NavItem title="Klær og Tekstiler" subitems={["Bodyer", "Soveposer", "Tepper", "Yttertøy", {label: "Merkelapper", url: "/produkter/merkelapper"}]}></NavItem>
				<NavItem title="Leker og Underholdning" subitems={["Babygym", "Uteleker"]}></NavItem>
				<NavItem title="Møbler" subitems={["Oppbevaring", "Stoler", "Kommoder"]}></NavItem>
				<NavItem title="Merkelapper" subitems={[{label: "Merkelapper", url: "/produkter/merkelapper"}]}></NavItem>
			</ul>
		</nav>
	)
}